<template>
  <div class="authoring-wrapper">
    <div class="flex h-full">
      <ProgressBar
        :stepIndex="3"
        :surveyID="surveyID"
        stepsType="brand-fingerprint"
        :conciergeAssistance="false"
      />
      <section class="wrapper">
        <a-breadcrumb class="breadcrum breadcrum--authoring">
          <template v-if="user !== null && user.SkinIdentifier !== 'pg'">
            <a-breadcrumb-item
              ><a href="/">{{ client.ClientName }}</a></a-breadcrumb-item
            >
            <a-breadcrumb-item
              ><a href="/products">Products</a></a-breadcrumb-item
            >
            <a-breadcrumb-item>Stimuli</a-breadcrumb-item>
          </template>
        </a-breadcrumb>
        <div class="wrapper__inner">
          <div class="page-title">
            <icon-base
              :width="32"
              :height="33"
              :viewBox1="32"
              :viewBox2="33"
              iconName="chart"
              iconColor="transparent"
              ><icon-chart-histogram
            /></icon-base>
            <div class="page-title__text">
              <h1>Stimuli</h1>
            </div>
          </div>
          <div class="box-wrapper">
            <StimuliTitle
              title="Please upload the imagery you want to show for each cell/brand you've selected."
            ></StimuliTitle>
            <div>
              <ChosenBrandItem
                v-for="(item, index) in brands"
                :key="index"
                :brand="item"
                :surveyID="surveyID"
                @set-brand-image="setBrandImage($event, index)"
                :loadingBrands="loadingBrands"
              ></ChosenBrandItem>
            </div>
          </div>

          <StepNaviBar
            :nextDisable="nextDisable"
            :conciergeAssistance="true"
            @prevHandler="prevStep"
            @nextHandler="nextStep"
            stepsType="brand-fingerprint"
            @editable-survey-updated="handleEditableSurveyUpdate"
            @loading-survey-data="loadingBrands = $event"
            :loadingNextBtn="saveBrandsLoading"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import * as jsUtils from "@/utils/jsUtils.js";
import * as wsUtils from "@/utils/wsUtils.js";
import StimuliTitle from "@/components/packTestSurvey/StimuliTitle.vue";
import IconBase from "@/components/general/IconBase.vue";
import IconChartHistogram from "@/components/icons/IconChartHistogram.vue";
import ProgressBar from "@/components/videoAds/ProgressBar.vue";
import ChosenBrandItem from "@/components/mapMakerTest/ChosenBrandItem.vue";
import StepNaviBar from "@/components/videoAds/StepNaviBar1.vue";
import surveyPriceMixin from "@/mixins/surveyPriceCalculation.js";

export default {
  name: "StimuliBrandFingerprint",
  components: {
    StimuliTitle,
    IconBase,
    IconChartHistogram,
    ProgressBar,
    StepNaviBar,
    ChosenBrandItem,
  },
  props: {},
  data() {
    return {
      client: {},
      user: null,
      brands: [],
      surveyID: null,
      loadingBrands: true,
      saveBrandsLoading: false,
      implicitComponent: true,
    };
  },
  mixins: [surveyPriceMixin],
  computed: {
    disableNextStep() {
      return true;
    },
    nextDisable() {
      return this.brands.some((item) => !item.logoURL);
    },
    progressBarStatus() {
      let imageUploaded = this.brands.some((item) => item.logoURL);
      return [imageUploaded];
    },
  },
  watch: {},
  methods: {
    setImplicit(surveyData) {
      const cfg = surveyData && surveyData.SurveyConfig;
      if (cfg && cfg.implicitComponent !== undefined) {
        this.implicitComponent = cfg.implicitComponent;
      } else {
        this.implicitComponent = false;
      }
    },
    handleEditableSurveyUpdate(surveyData) {
      if (surveyData && surveyData.SurveyConfig && surveyData.brands) {
        this.brands = surveyData.brands;
        this.setImplicit(surveyData);
      } else {
        this.brands = [];
      }
    },
    setBrandImage(imageURL, index) {
      this.brands[index].logoURL = imageURL;
      this.saveBrands();
    },
    saveBrands(nextStep) {
      if (nextStep) {
        this.saveBrandsLoading = true;
      }

      const data = {
        wsName: "SaveSurveyBrands",
        data: {
          surveyID: this.surveyID,
          brandData: this.brands,
          userId: this.user.EncrypteduserID,
          isSelected: false,
        },
      };

      const saveBrands = new Promise((resolve) => {
        wsUtils.ApiPost(data, resolve);
      });

      saveBrands.then((data) => {
        if (data.Success && nextStep) {
          let routeName = "pgnat-brand-fingerprint";
          if (!this.implicitComponent) {
            routeName = "brand-fingerprint-quotas";
          }
          this.$router.push({
            name: routeName,
            params: { id: this.surveyID },
          });
        } else if (data.Success) {
          let currentSummaryData = jsUtils.getSurveySummaryData();
          jsUtils.setSurveySummaryData({
            ...currentSummaryData,
            mapMakerBrandData: this.brands,
          });
        }
        this.getBrandFingerprintPrice();
        this.saveBrandsLoading = false;
      });
    },
    prevStep() {
      this.$router.push({
        name: "brand-fingerprint-category-inputs",
        params: { id: this.surveyID },
      });
    },
    nextStep() {
      this.saveBrands("nextStep");
    },
  },
  mounted() {},
  created() {},
  activated() {
    window.scrollTo({
      top: 0,
    });
    this.surveyID = this.$route.params.id;
    this.client = jsUtils.getCurClient();
    this.user = jsUtils.getUserInfo();
    this.getBrandFingerprintPrice();
  },
};
</script>

<style lang="scss" scoped>
.box-wrapper {
  min-height: 200px;
}
</style>
